export enum RcRating {
  OutperformStrong = 'Outperform/Strong',
  MarketperformNeutral = 'Marketperform/Neutral',
  UnderperformWeak = 'Underperform/Weak',
  NotRated = 'Not Rated',
}
